import React, { useEffect, useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"
import { bindActionCreators } from "redux"
import { Actions } from "../../Action"
import { getDomainSpecificTimelineDataExpertOverview } from "../../API/api"
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Label, LabelList, Cell, Bar, BarChart } from 'recharts';
import moment from "moment"
import { Spin, Dropdown } from "antd"
import SelectComponentForDomainSpecificInCMexpert from '../SelectMonthsDurationCMGraphs/SelectComponentForDomainSpecificInCMexpert'
import VizHeader from "../VizHeader/VizHeader"
import FileSaver, { saveAs } from "file-saver"
import * as htmlToImage from 'html-to-image';
import { useCurrentPng } from "recharts-to-png"
import { includes } from "lodash"
import SelectComp from "../../NewComponent/Select/Select"
import ChartToggleComponent from "../../NewComponent/ChartToggleComponent/ChartToggleComponent"
import { toggleChartRegionValues } from "../../utils"
// import styles from './domain.module.css'
const containerStyles1 = {
    width: "80%",
    margin: "auto",
    // marginTop:"1%",
    // marginTop: "6%",
    // marginBottom: "7%",
    // border: '1px solid #EAECF0',
    // boxShadow: '0px 4px 16px 0px #1018280F',
    // borderRadius: '12px',
    // minHeight:'450px',
    padding: '0px 24px 0px 0px',
    // paddingBottom:'0px'
    // Height:"100%"
  
  
  
  
  };

export default function DomainSpecificGraphComponent(props) {
	const dispatch = useDispatch()
	const { getDomainSpecificTimelineData } = bindActionCreators(Actions, dispatch)
	const userState = useSelector((state) => state.user);
	const cmRootReducer = useSelector((state) => state.cmRoot)
	const overviewReducer = useSelector((state) => state.cmOverview)
	const expertOverview = useSelector((state) => state.expertOverviewCmReducer)
	const [loading, setLoading] = React.useState(false);
	const [getRatingsPng, { ref: domainSpecific }] = useCurrentPng();
	const [getRegionData, setRegionData] = React.useState([])
	const [getRegionKeys, setRegionKeys] = React.useState([])
	const [activeIndex, setActiveIndexIn] = React.useState(0);
	const [getTooltipPayload, setTooltipPayload] = React.useState([]);
	const [activeKeys, setActiveKeys] = React.useState([props.domain]);
	const [opacity, setOpacity] = React.useState({ [props.domain]: 1 })
	const [activeRegions, setActiveRegions] = React.useState([]);
	const [activeLegendRegion, setActiveLegendRegion] = React.useState(null);
	const [activeChartType, setActiveChartType] = React.useState({ id: 1, type: 'line' })
	const [dropdownToggle, setDropdowntoggle] = React.useState(false)
	const [changeDomainValue, setDomainValue] = React.useState(props.domain)
	const dropdownRef = React.useRef(null)
	const selectRef = React.useRef(null)

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (!dropdownRef.current) return;

			const isClickInsideDropdown = dropdownRef.current.contains(event.target);

			let isClickInsideSelectDropdown = false;
			let node = event.target;
			while (node) {
				if (node.classList && node.classList.contains('ant-select-dropdown')) {
					isClickInsideSelectDropdown = true;
					break;
				}
				node = node.parentNode;
			}

			if (!isClickInsideDropdown && !isClickInsideSelectDropdown) {
				setDropdowntoggle(false);
			}
		};

		if (dropdownToggle) {
			document.addEventListener('mousedown', handleClickOutside);
		} else {
			document.removeEventListener('mousedown', handleClickOutside);
		}
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};

		// const handleClickOutside=(event)=>{
		// 	if(!dropdownRef.current) return;

		// 	const isClickInsideDropdown=dropdownRef.current.contains(event.target);
		// 	let isClickInsideSelectDropdown=false
		// 	let node=event.target;
		// 	while(node){
		// 		if(node.classList&&node.classList.contains('ant-select-dropdown')){
		// 			isClickInsideDropdown=true;
		// 			break;
		// 		}
		// 		node=node.parentNode
		// 	}
		// 	if(!isClickInsideDropdown && !isClickInsideSelectDropdown){
		// 		setDropdowntoggle(false)
		// 	}
		// };
		// if(dropdownToggle){
		// 	add.addEventListener('mousedown',handleClickOutside)
		// }else{
		// 	document.removeEventListener('mousedown',handleClickOutside);
		// }

		// return ()=>{
		// 	document.removeEventListener('mousedown',handleClickOutside)
		// }


	}, [dropdownToggle])

	useEffect(() => {
		if (cmRootReducer.selecetdRoutingValue !== "") {
			setLoading(true)
			getDomainSpecificTimelineDataExpertOverview(props.domain, expertOverview.domainSpecificDuration.value, cmRootReducer.selecetdRoutingValue, cmRootReducer.selectedGeoLevel.length === 0 ? "" : cmRootReducer.selectedGeoLevel.label, cmRootReducer.selectedDomainIds, overviewReducer.userTypeSelect.value).then((res) => {
				if (res === undefined) return;
				if (res.data.data !== undefined || res.data.success) {
					function getValuesForGeoLevels(val) {
						if (cmRootReducer.selecetdRoutingValue === 1) {
							val = cmRootReducer.selectedGeoLevel.label
							return val;
						}
						if (cmRootReducer.selecetdRoutingValue === 2) {
							const formatData = (objj) => {
								let dates = Object.keys(objj).sort();
								let newArr = [];
								dates.filter((obj, index) => {
									newArr.push({ date: obj });
									Object.keys(objj[obj]).filter(ct => {
										newArr[index] = { ...newArr[index], [ct]: Object.values(objj[obj][ct]).reduce((a, b) => a + b, 0) };
									})
								})
								setRegionData(newArr)
								return newArr
							}
							formatData(res.data.data)
							setRegionKeys(Object.values(res.data.data).map((ob) => { return Object.keys(ob) }))
							setActiveRegions(Object.values(res.data.data).map((ob) => { return Object.keys(ob) })[0])
						}
						if (cmRootReducer.selecetdRoutingValue === 3) {
							val = 'Global'
							return val;
						}
					}
					setLoading(false)
					// getDomainSpecificTimelineData(res.data.data)
					let newArray = [];
					newArray = Object.entries(res.data.data).sort().map(([date, value]) => ({ date, ...value }));
					let newArray2 = newArray.map((obj, ind) => { return { date: moment(obj.date).format('MMM DD, YYYY'), ...obj[getValuesForGeoLevels('Global')] } })
					getDomainSpecificTimelineData(newArray2)

				}
			})
		}
		// return(()=>{
		// 	onComponentUnMount()
		// })
	}, [cmRootReducer.selecetdRoutingValue, cmRootReducer.selectedGeoLevel.length !== 0 && cmRootReducer.selectedGeoLevel.label, overviewReducer.userTypeSelect, expertOverview.domainSpecificDuration])


	const renderLabelValue = (val) => {
		if (val === null) {
			return "Last Month (UTC Timezone)"
		}
		if (val === '3months') {
			return "Last 3 months"
		}
		if (val === '6months') {
			return "Last 6 months"
		}
		if (val === '12months') {
			return "Last 12 months"
		}
		if (val === '-1months') {
			return "Year-To-Date"
		}
	}

	const items = [
		{
			key: "1",
			label: (
				// <a target="_blank" rel="noopener noreferrer" href="https://www.antgroup.com">
				//   1st menu item
				// </a>
				<div onClick={() => handleAreaDownload()}>Download as PNG Image</div>
			),
		},
		{
			key: "2",
			label: (
				<div onClick={() => downloadSvgAsJpeg()}>Download as JPEG Image</div>
			),
		},
		{
			key: "4",
			label: (
				<div onClick={() => handleDownloadSVG()}>Download SVG Vector image</div>
			),
		},
	];

	const handleAreaDownload = React.useCallback(async () => {
		const png = await getRatingsPng();
		if (png) {
			FileSaver.saveAs(png, `domains-in-${props.domain}.png`);
		}
	}, [getRatingsPng]);

	function downloadSvgAsJpeg() {
		htmlToImage.toJpeg(document.getElementsByClassName('recharts-wrapper')[5], { quality: 0.8, backgroundColor: '#fff' }, { backgroundColor: '#fff' })
			.then(function (dataUrl) {
				var link = document.createElement('a');
				link.download = 'domain-specific-graph.jpeg';
				link.href = dataUrl;
				link.click();
			});

	}

	const handleDownloadSVG = () => {
		const chartContainer =
			document.getElementsByClassName("recharts-wrapper")[5];
		const chartSvg = chartContainer.querySelector("svg");
		const chartXml = new XMLSerializer().serializeToString(chartSvg);
		const svgBlob = new Blob([chartXml], {
			type: "image/svg+xml;charset=utf-8",
		});
		saveAs(svgBlob, "domain-specific-graph.svg");
	};

	const COLORS = [
		'#009bff',
		'#00b8e6',
		'#b85cff',
		'#5e3bff',
		'#f4c900',
		'#ef7928',
		'#00c16e',
		"#7cb5ec",
		"#434348",
		"#90ed7d",
		"#f7a35c",
		"#8085e9",
		"#f15c80",
		"#e4d354",
		"#2b908f",
		"#f45b5b",
		"#91e8e1",
	];

	const handleMouseEnterRegion = (useCallback((data, index) => {
		setActiveIndexIn(index);
		setTooltipPayload(data?.tooltipPayload);
	}, []));

	const handleMouseOutRegion = () => {
		setActiveIndexIn(0)
		setTooltipPayload([])
	}

	const CustomTooltipForDomains = ({ active, payload, label }) => {
		if (active && payload.length > 0) {
			return (
				<p className="custom-tooltip" style={{ backgroundColor: '#fff', padding: '5px', border: `1px solid ${getTooltipPayload.length > 0 ? getTooltipPayload[0].fill : '#ececec'}` }}>
					{getTooltipPayload.length === 0 && (
						<>
							<p className="label">{moment(label).format('MMM DD, YYYY')}</p>
							{/* <p className="label" style={{ fontWeight: 500 }}>Total:0</p> */}
						</>
					)}
					{getTooltipPayload.map((ob, ind) => {
						return (
							<>
								<p className="label">{moment(ob.payload.date).format('MMM DD, YYYY')}</p>
								{ob.payload[ob.dataKey] > 0 && <p className="label" style={{ fontWeight: 500 }}>{ob.dataKey}:{" "}{ob.payload[ob.dataKey]}</p>}
							</>
						)
					})}
				</p>)
		}
	}

	const handleLegendClick = (e) => {
		const { dataKey } = e;
		const isActive = activeKeys.includes(dataKey);

		// If active, remove it from activeKeys; if not active, add it
		setActiveKeys((prevActiveKeys) =>
			isActive ? prevActiveKeys.filter((key) => key !== dataKey) : [...prevActiveKeys, dataKey]
		);
		// setLegendClicked(!legendClicked)
		// setLegendName(name)
	};

	const handleLegendClickRegion = (e) => {
		const { dataKey } = e;
		const isActive = activeRegions.includes(dataKey);

		// If active, remove it from activeKeys; if not active, add it
		setActiveRegions((prevActiveKeys) =>
			isActive ? prevActiveKeys.filter((key) => key !== dataKey) : [...prevActiveKeys, dataKey]
		);
		// setLegendClicked(!legendClicked)
		// setLegendName(name)
	}

	const handleMouseEnter = (o) => {
		const { dataKey } = o;
		setOpacity((prevOpacity) => ({
			...prevOpacity,
			[dataKey]: 0.2,
		}));
	};

	const handleMouseEnterRegionLegend = (data) => {
		setActiveLegendRegion(data.dataKey)
	}

	const handleMouseOutRegionLegend = () => {
		setActiveLegendRegion(null)
	}

	const handleMouseLeave = (o) => {
		const { dataKey } = o;
		setOpacity((prevOpacity) => ({
			...prevOpacity,
			[dataKey]: 1,
		}));
	};

	const CustomizedTooltipForGlobalAndCountry = ({ active, payload, label }) => {
		if (active && payload && payload.length > 0) {
			return (
				<>
					<p className="custom-tooltip" style={{ backgroundColor: '#fff', padding: '5px', border: '1px solid #ececec' }}>
						<p className="label">{payload[0].payload.date}</p>
						{payload[0].value > 0 && (
							<p className="label" style={{ color: `${payload[0].color}`, fontWeight: 'bold' }}>{payload[0].name}:{" "}{payload[0].value}</p>
						)}
					</p>
				</>
			)
		}
	}

	const onClickChangeChartType = (value) => {
		setActiveChartType(value)
	}


	return (
		<>

			<div style={{ position: 'relative', padding: '10px', backgroundColor: '#fff', borderRadius: '8px' }}>
				{/* Header Row */}
				<div style={{ display: 'flex', width: '100%', justifyContent: 'flex-end', paddingTop: '7px' }}>
					<div style={{ width: '30%' }}></div>
					<div style={{ width: '40%', textAlign: 'center' }}>
						<VizHeader type={4} isBold={true}>Questions in {props.domain}</VizHeader>
					</div>
					<div style={{ width: '30%', display: 'flex', justifyContent: 'flex-end', paddingRight: '12px' }}>
						<i onClick={() => setDropdowntoggle(!dropdownToggle)} style={{ fontSize: '24px', cursor: 'pointer' }} className="fa fa-gear" />
					</div>
				</div>

				{/* Chart and Spinner */}
				<Spin spinning={loading}>
					{(cmRootReducer.selecetdRoutingValue === 3 || cmRootReducer.selecetdRoutingValue === 1)
						&& activeChartType.id === 1 &&
						<ResponsiveContainer width="100%" height={420}>
							<LineChart
								// width={500}
								height={300}
								data={expertOverview.domainSpecificData}
								margin={{
									top: 5,
									right: 30,
									left: 20,
									bottom: 20,
								}}
								strokeWidth={1.5}
								ref={domainSpecific}
							>
								<CartesianGrid stroke="#ececec" vertical={false} />
								<XAxis interval={"equidistantPreserveStart"} angle={-45} dy={10} dx={2} fontSize={12} dataKey="date" tickFormatter={(value) => moment(value).format('MMM-DD')}>
									<Label fontWeight={"bold"} value={renderLabelValue(expertOverview.domainSpecificDuration.value)} dy={32} fontSize={12} />
								</XAxis>
								<YAxis fontSize={12} allowDecimals={false} axisLine={false} tickLine={false}>
									<Label fontSize={12} fontWeight="bold" angle={-90} value={"Questions In " + props.domain} />
								</YAxis>
								<Tooltip wrapperStyle={{ fontSize: '12px', fontWeight: 'bold' }} cursor={{ fill: 'transparent' }} content={<CustomizedTooltipForGlobalAndCountry />} />
								<Legend wrapperStyle={{ fontSize: '12px', bottom: -3, padding: '5px', fontWeight: 'bold', cursor: 'pointer' }} onClick={handleLegendClick} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} />
								<Line hide={!activeKeys.includes(`${props.domain}`)} type="bump" dataKey={props.domain} stroke="#009bff" strokeWidth={2} isAnimationActive={false} />
							</LineChart>
						</ResponsiveContainer>}
					{(cmRootReducer.selecetdRoutingValue === 3 || cmRootReducer.selecetdRoutingValue === 1) && (activeChartType.id === 2)
						&& (
							<>
								<ResponsiveContainer width={'100%'} height={420}>
									<BarChart
										data={expertOverview.domainSpecificData}
										margin={{
											top: 20,
											right: 20,
											left: 20,
											bottom: 15,
										}}
										barSize={20}
										stackOffset="sign"
										ref={domainSpecific}
									>
										<CartesianGrid vertical={false} stroke="#ececec" />
										<XAxis angle={-45} offset={7} dy={10} dx={2} tickMargin={5} dataKey="date" fontSize={12} tickFormatter={(value) => moment(value).format('MMM-DD')}>
											<Label fontWeight={"bold"} value={expertOverview.domainSpecificDuration.label} dy={32} dx={7} fontSize={12} />
										</XAxis>
										<YAxis fontSize={12} allowDecimals={false} axisLine={false} tickLine={false}>
											<Label fontWeight={"bold"} fontSize={12} angle={-90} value={"Questions In " + props.domain} dx={-22} />
										</YAxis>
										<Tooltip wrapperStyle={{ fontSize: '12px', fontWeight: 'bold' }} cursor={{ fill: 'transparent' }} content={<CustomizedTooltipForGlobalAndCountry />} />
										<Bar hide={!activeKeys.includes(`${props.domain}`)} fill="#009bff" dataKey={props.domain} />
										<Legend wrapperStyle={{ fontSize: '12px', bottom: -3, padding: '5px', fontWeight: 'bold', cursor: 'pointer' }} onClick={handleLegendClick} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} />
									</BarChart>
								</ResponsiveContainer>
							</>
						)
					}
					{
						cmRootReducer.selecetdRoutingValue === 2 &&
						(
							<>
								<ResponsiveContainer width="100%" height={420}>
									<BarChart
										data={getRegionData}
										margin={{
											top: 20,
											right: 20,
											left: 20,
											bottom: 15,
										}}
										barSize={20}
										stackOffset="sign"
										ref={domainSpecific}
									>
										<CartesianGrid vertical={false} stroke="#ececec" />
										<XAxis angle={-45} offset={7} dy={10} dx={2} tickMargin={5} dataKey="date" fontSize={12} tickFormatter={(value) => moment(value).format('MMM-DD')}>
											<Label fontWeight={"bold"} value={expertOverview.domainSpecificDuration.label} dy={32} dx={7} fontSize={12} />
										</XAxis>
										<YAxis fontSize={12} allowDecimals={false} axisLine={false} tickLine={false}>
											<Label fontWeight={"bold"} fontSize={12} angle={-90} value={"Questions In " + props.domain} dx={-22} />
										</YAxis>
										<Tooltip wrapperStyle={{ fontSize: '12px', fontWeight: 'bold' }} cursor={{ fill: 'transparent' }} content={<CustomTooltipForDomains />} />
										<Legend onMouseEnter={handleMouseEnterRegionLegend} onMouseLeave={handleMouseOutRegionLegend} wrapperStyle={{ fontSize: '12px', fontWeight: 'bold', padding: '5px', bottom: -3, cursor: 'pointer' }} onClick={handleLegendClickRegion} />
										{
											getRegionKeys[0]?.map((o, ind) =>
												<Bar onMouseOver={handleMouseEnterRegion}
													onMouseOut={handleMouseOutRegion}
													// onMouseOut={handleMouseOutRegionLegend}
													dataKey={o} stackId={"a"} fill={COLORS[ind % COLORS.length]}
													hide={!activeRegions.includes(o)}
													opacity={activeLegendRegion === o || activeLegendRegion === null ? 1 : 0.2}
												>
													<Cell />
												</Bar>
											)
										}
									</BarChart>
								</ResponsiveContainer>
							</>
						)
					}
				</Spin>

				{/* Dropdown Overlay */}
				{dropdownToggle && (
					<div style={{
						position: 'absolute',
						top: '50px',
						right: '10px',
						width: '240px',
						backgroundColor: '#fff',
						padding: '12px',
						border: '1px solid #ccc',
						borderRadius: '8px',
						boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
						zIndex: 10
					}}
						ref={dropdownRef}
					>
						<div style={{ textAlign: 'end' }}>
							<i onClick={() => setDropdowntoggle(false)} className="fa fa-close" style={{ fontSize: '18px', cursor: 'pointer' }} />
						</div>
						<div ref={selectRef}>

						<SelectComponentForDomainSpecificInCMexpert />
						</div>
						{toggleChartRegionValues(cmRootReducer.selecetdRoutingValue) && (
							<div style={{ textAlign: 'end', paddingTop: '10px' }}>
								<ChartToggleComponent onClickFunction={() => onClickChangeChartType({ id: 1, type: 'line' })} value={activeChartType} fontSize={'24px'} type={'line'} />
								&nbsp;&nbsp;&nbsp;
								<ChartToggleComponent onClickFunction={() => onClickChangeChartType({ id: 2, type: 'bar' })} value={activeChartType} fontSize={'24px'} type={'bar'} />
							</div>
						)}
						<div style={{ paddingTop: '15px', textAlign: 'end' }}>
							<span style={{ fontSize: '14px', color: '#5c667b' }}>Download PNG</span>
							<span onClick={() => handleAreaDownload()} style={{ marginLeft: '8px', border: '1px solid #d9d9d9', padding: '5px', cursor: 'pointer' }}>
								<i className="fa fa-download" />
							</span>
						</div>
						<div style={{ paddingTop: '10px', textAlign: 'end' }}>
							<span style={{ fontSize: '14px', color: '#5c667b' }}>Download JPEG</span>
							<span onClick={() => downloadSvgAsJpeg()} style={{ marginLeft: '8px', border: '1px solid #d9d9d9', padding: '5px', cursor: 'pointer' }}>
								<i className="fa fa-download" />
							</span>
						</div>
						<div style={{ paddingTop: '10px', textAlign: 'end' }}>
							<span style={{ fontSize: '14px', color: '#5c667b' }}>Download SVG</span>
							<span onClick={() => handleDownloadSVG()} style={{ marginLeft: '8px', border: '1px solid #d9d9d9', padding: '5px', cursor: 'pointer' }}>
								<i className="fa fa-download" />
							</span>
						</div>
					</div>
				)}
			</div>

		</>
	)
}